'use client';
import { useMutation } from '@tanstack/react-query';

import { ContactFormData } from '@/views/ContactUs/subcomponents/ContactForm.schema';
import { sendContactMessage } from '../api/contact.api';

export const useSendContactMessage = () => {
  return useMutation({
    mutationFn: (data: ContactFormData) => sendContactMessage(data),
  });
};
